import { tw } from "@careinfo/tailwind";
import { CellContext } from "@tanstack/react-table";
import React from "react";
import { Link } from "react-router-dom";
import { DeleteIcon } from "../../icons/DeleteIocn";
import EditIcon from "../../icons/EditIcon";
import { queryClient } from "../../root.component";
import TableActionButton from "../TableActionButton";

type Props = CellContext<any, string> & {
  /**
   * Callback that provides the id of current cell
   * @param {string} id - id of current cell
   */
  handleDeleteClick?: (id: string) => void;
  /**
   * Path to redirect user for updating the data
   * of current cell
   */
  editPath?: string;
  /**
   * Specifies if the document should reload or not
   * when clciked on edit icon
   */
  reload?: boolean;
};

const ActionCell: React.FC<Props> = ({
  getValue,
  handleDeleteClick,
  editPath,
  reload = false,
}) => {
  return (
    <div className={tw`flex items-center space-x-6`}>
      {editPath && (
        <Link
          reloadDocument={reload}
          to={editPath}
          className={tw`cursor-pointer`}
        >
          <EditIcon color={"var(--primary)"} />
        </Link>
      )}
      {handleDeleteClick && (
        <button
          className={tw`w-5 h-5 focus:outline-none`}
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteClick(getValue());
          }}
        >
          <DeleteIcon color={"var(--primary)"} />
        </button>
      )}
    </div>
  );
};

export default ActionCell;
